import React, { useEffect, useState } from 'react';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">Contact Us</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> Contact
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-card">
              <h3 style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 24, marginBottom: 32 }}>Get In Touch</h3>

              <div className="contact-info-item">
                <div className="contact-info-icon">📍</div>
                <div>
                  <div className="contact-info-label">Venue / Location</div>
                  <div className="contact-info-value">Best Western Plus Hotel, Soaho Douala Airport</div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">✉️</div>
                <div>
                  <div className="contact-info-label">Email Us</div>
                  <div className="contact-info-value">info@linkedinlocalcameroon.com</div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">📞</div>
                <div>
                  <div className="contact-info-label">Call Us</div>
                  <div className="contact-info-value">+237 683 66 85 18</div>
                </div>
              </div>

              <div className="contact-social">
                <a href="https://www.linkedin.com/company/linkedin-local-cameroon/" target="_blank" rel="noreferrer" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 800 }}>in</a>
                <a href="https://www.facebook.com/profile.php?id=61587542943056" target="_blank" rel="noreferrer" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 800 }}>f</a>
                <a href="https://www.instagram.com/linkedinlocalcameroon?igsh=bm9oZDY4ZHM0cTM2" target="_blank" rel="noreferrer" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 800 }}>ig</a>
              </div>
            </div>

            {/* Contact Form */}
            <div className="reg-form" style={{ padding: 40 }}>
              <h3 style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 24, marginBottom: 24 }}>Send a Message</h3>
              {submitted ? (
                <div style={{ padding: 30, textAlign: 'center', background: 'var(--blue-light)', borderRadius: 8 }}>
                  <div style={{ fontSize: 40, color: '#16a34a', marginBottom: 12 }}>✓</div>
                  <h4 style={{ fontFamily: 'Montserrat, sans-serif', fontSize: 20, marginBottom: 8, color: 'var(--blue)' }}>Message Sent!</h4>
                  <p>We've received your message and will get back to you shortly.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-input" required />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Email</label>
                      <input type="email" className="form-input" required />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Subject</label>
                    <input type="text" className="form-input" required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Message</label>
                    <textarea className="form-input form-textarea" required></textarea>
                  </div>
                  <button type="submit" className="form-submit mt-4">Send Message</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
